<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <h3>GENERADOR CERTIFICADO DISPOSICIÓN</h3>
          <p :style="{fontWeight: '700', marginBottom: '5px'}" v-if="reemitir">
            (Reemitiendo certificado N°{{ certificado.correlativo }})
          </p>
          <span :style="{fontSize: '0.9rem', opacity: 0.85}">Seleccione fechas y tipo de certificado para habilitar selección de empresa y planta.</span>
        </div>
      </div>
      <div class="row row-items" :style="{paddingTop: '1.1rem'}">
        <div class="col">
          <label for="fechas">Seleccione fechas: </label>
          <date-picker id="fechas" v-model="certificado.fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="false" value-type="YYYY-MM-DD" @change="cargarEmpresas" class="datepicker"></date-picker>
        </div>

        <div class="col">
          <label for="tipos_cetificados">Seleccione tipo de certificado: </label>
          <v-select id="tipos_cetificados" :reduce="option => option.id" v-model="certificado.tipo_certificado" :options="tipos_certificados" label="name" @input="cargarEmpresas"/>
        </div>
        
        <div class="col">
          <label for="tipos_cetificados">
            {{certificado.tipo_certificado === 5 ? 'Seleccione empresas' : 'Seleccione empresa'}}
          </label>
          <v-select id="tipos_cetificados" class="" :reduce="option => option.id" v-model="certificado.empresas_id" :options="empresas" label="nombre" :disabled="selectDesactivado('empresa')" @input="cargarPlantas" :multiple="certificado.tipo_certificado === 5">
            <template v-slot:no-options>
              <em style="opacity: 0.5;">No hay empresas disponibles</em>
            </template>
          </v-select>
        </div>

        <div class="col" v-show="certificado.tipo_certificado === 5">
          <label for="tipos_cetificados">Seleccione empresa principal: </label>
          <v-select id="tipos_cetificados" class="" :reduce="option => option.id" v-model="certificado.empresas_id_principal" :options="empresas_seleccionadas" label="nombre">
            <template v-slot:no-options>
              <em style="opacity: 0.5;">No hay empresas disponibles</em>
            </template>
          </v-select>
        </div>
      </div>

      <div class="row row-items">
        <div class="col col-4">
          <label for="tipos_cetificados" class="mb-1">Seleccione planta: </label>
          <div class="checkbox-container-plantas">
            <input type="checkbox" id="seleccionar_todo_plantas" :checked="plantas_seleccionadas" @change="seleccionarPlantas">
            <label for="seleccionar_todo_plantas">Seleccionar todas</label>
          </div>
          <v-select class="" :reduce="option => option.id" v-model="certificado.sucursal_id" :options="plantas" label="nombre" :disabled="selectDesactivado('planta')" multiple>
            <template v-slot:no-options>
              <em style="opacity: 0.5;">No hay plantas disponibles</em>
            </template>
          </v-select>
        </div>

        <div class="col col-4">
          <label for="numero_guia">Número guía</label>
          <div>
            <input id="numero_guia" class="input" v-model="certificado.numero_guias"></input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col btn-container">
          <button class="btn btn-primary btn-icon" :disabled="boton_desactivado" @click="generarCertificado">Generar</button>

          <div>
            <div class="checkbox-container">
              <input id="empresa" type="checkbox" v-model="certificado.agregar_empresa"></input>
              <label for="empresa">Agregar empresa</label>
            </div>

            <div class="checkbox-container">
              <input id="direccion" type="checkbox" v-model="certificado.agregar_direccion"></input>
              <label for="direccion">Agregar dirección</label>
            </div>

            <div class="checkbox-container" v-if="[2, 5, 6].includes(certificado.tipo_certificado)">
              <input id="destino_vertedero" type="checkbox" v-model="certificado.agregar_destino_vertedero"></input>
              <label for="destino_vertedero">Agregar destino</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="modal_certificado" data-backdrop="static" data-keyboard="false" tabindex="-1"
      role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-xl`" role="document" :style="{maxWidth: '1000px'}">
        <div class="modal-content">
          <div class="modal-header" style="background-color:#172b4d;">
            <h5 class="modal-title" style="color:#fff">
              {{ titulo_modal }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
              <span aria-hidden="true" style="color:#fff;font-size:1.2em">&times;</span>
            </button>
          </div>
          <div class="modal-body" :style="{paddingBottom: '0'}">
            <iframe :src="certificado_url" :style="{width: '100%', height: '70vh'}"></iframe>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary btn-icon" @click="confirmarCertificado">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Swal from "sweetalert2";

export default {
  data: () => ({
    certificado: {
      tipo_certificado: null,
      empresas_id: null,
      empresas_id_principal: null, // Solo para certificado de mortalidad ensilada a relleno
      sucursal_id: [],
      fechas: null,
      correlativo: null,
      agregar_direccion: false,
      agregar_empresa: false,
      agregar_destino_vertedero: false,
      numero_guias: "",
    },
    tipos_certificados: [
      {id: 1, name: 'Certificado Subproducto a Proceso'},
      {id: 2, name: 'Certificado Subproducto a Relleno'},
      {id: 3, name: 'Certificado Mortalidad Ensilada'},
      {id: 4, name: 'Certificado Mortalidad Entera'},
      {id: 5, name: 'Certificado Mortalidad Ensilada a Relleno'},
      {id: 6, name: 'Certificado Mortalidad No Ensilada a Relleno'},
    ],
    reemitir: false,
    empresas: [],
    plantas: [],
    certificado_url: null,
    titulo_modal: null,
  }),

  mounted() {
    if (this.$route.params.correlativo) {
      this.reemitir = true;
      this.certificado.correlativo = this.$route.params.correlativo;
    }
  },

  methods: {
    async cargarEmpresas () {
      this.certificado.empresas_id_principal = null;

      this.certificado.agregar_empresa = this.certificado.tipo_certificado === 3;
      if (!this.certificado.fechas || !this.certificado.tipo_certificado) return;

      this.certificado.empresas_id = null;
      this.certificado.sucursal_id = [];
      const loader = this.showLoader();
      const url = `${this.api}/certificado/cargar_empresas`;
      const certificado = {
        tipo_certificado: this.certificado.tipo_certificado,
        desde: this.certificado.fechas[0],
        hasta: this.certificado.fechas[1],
      }

      await this.axios
        .post(url, certificado, this.cabeceras_json)
        .then(res => {
          this.empresas = res.data;
        })
        .catch(e => {
          //alert(e);
        });

      loader.hide();
    },

    async cargarPlantas () {
      if (!this.certificado.fechas || !this.certificado.tipo_certificado || !this.certificado.empresas_id) return;
      if (Array.isArray(this.certificado.empresas_id) && this.certificado.empresas_id.length === 0) return;
      
      this.certificado.sucursal_id = [];

      const loader = this.showLoader();
      const url = `${this.api}/certificado/cargar_plantas`;
      const certificado = {
        tipo_certificado: this.certificado.tipo_certificado,
        empresas_id: this.certificado.empresas_id,
        desde: this.certificado.fechas[0],
        hasta: this.certificado.fechas[1],
      }

      await this.axios
        .post(url, certificado, this.cabeceras_json)
        .then(res => {
          this.plantas = res.data;
          if (this.certificado.tipo_certificado === 3) {
            this.certificado.sucursal_id = this.plantas.map(planta => planta.id);
            document.getElementById("seleccionar_todo_plantas").checked = true;
          }
        })
        .catch(e => {
          //alert(e);
        });

      loader.hide();
    },

    async generarCertificado() {
      const loader = this.showLoader();
      const url = `${this.api}/certificado/generar`;
      
      const sucursal_id = [];
      this.plantas.forEach(planta => {
        if (this.certificado.sucursal_id.includes(planta.id)) sucursal_id.push(planta.id);
      });
      this.certificado.sucursal_id = sucursal_id;
      
      if (this.certificado.tipo_certificado === 5) {
        const empresas_id = [];
        this.empresas.forEach(empresa => {
          if (this.certificado.empresas_id.includes(empresa.id)) empresas_id.push(empresa.id);
        });
        this.certificado.empresas_id = empresas_id;
      }

      const data = {
        certificado: {
          ...this.certificado,
          desde: this.certificado.fechas[0],
          hasta: this.certificado.fechas[1],
        },
        reemitir: this.reemitir,
      }

      await this.axios
        .post(url, data, this.cabeceras_json)
        .then(res => {
          if (!res.data.data) return;
          this.openModal(res.data.data);
        })
        .catch(e => {
          //alert(e);
        });
      loader.hide();
    },

    async confirmarCertificado() {
      const loader = this.showLoader();
      const url = `${this.api}/certificado/confirmar`;
      const data = {
        certificado: {
          ...this.certificado,
          desde: this.certificado.fechas[0],
          hasta: this.certificado.fechas[1],
        },
      }

      await this.axios
        .post(url, data, this.cabeceras_json)
        .then(async res => {
          if (res.data.data) this.closeModal();
          
          loader.hide();
          await Swal.fire({
            icon: "success",
            title: res.data.mensaje,
            confirmButtonColor: "#2dce89"
          });

          if (res.data.data) this.openModal(res.data.data);
        })
        .catch(e => {
          loader.hide();
        });

      this.reemitir = false;
    },

    showLoader() {
      return this.$loading.show({
        canCancel: false,
        color: "#262b63",
        backgroundColor: "#ededed",
        loader: "spinner",
      });
    },

    closeModal() {
      $("#modal_certificado").modal('hide');
      this.certificado_url = null;
      this.titulo_modal = null;
    },

    openModal(data) {
      this.certificado.correlativo = data.correlativo;
      this.certificado_url = `${this.api_public}/${data.filename}`;
      const tipo_certificado = this.tipos_certificados.find(certificado => certificado.id === this.certificado.tipo_certificado);
      if (tipo_certificado) this.titulo_modal = tipo_certificado.name;
      $("#modal_certificado").modal({ show: true });
    },

    selectDesactivado(select) {
      if (select === "empresa") {
        return !this.certificado.fechas || !this.certificado.tipo_certificado;
      }
      if (select === "planta") {
        return !this.certificado.fechas || !this.certificado.tipo_certificado || (!this.certificado.empresas_id || Array.isArray(this.certificado.empresas_id) && this.certificado.empresas_id.length === 0);
      }
      return false;
    },

    seleccionarPlantas(event) {
      if (event.target?.checked) this.certificado.sucursal_id = this.plantas.map(planta => planta.id);
      else this.certificado.sucursal_id = [];
    },
  },
  computed: {
    ...mapState(['cabeceras_json', 'api', 'api_public']),
    boton_desactivado() {
      return Object.entries(this.certificado).some(([key, value]) => {
        if (['correlativo', 'agregar_direccion', 'agregar_empresa', 'agregar_destino_vertedero', 'numero_guias'].includes(key)) return false; 
        if (key === 'sucursal_id') return !this.certificado.numero_guias && !value.length;
        if (key === 'empresas_id') return !value || (Array.isArray(value) && value.length == 0);
        if (key === 'empresas_id_principal') return this.certificado.tipo_certificado === 5 ? !value : false;
        return !value;
      });
    },
    select_desactivado() {
      return !this.certificado.fechas || !this.certificado.tipo_certificado;
    },
    plantas_seleccionadas() {
      if (this.plantas.length === 0) return false;
      return this.plantas.every(planta => this.certificado.sucursal_id.includes(planta.id));
    },
    empresas_seleccionadas() {
      if (!Array.isArray(this.certificado.empresas_id) || this.certificado.empresas_id.length === 0) return [];

      const empresas_seleccionadas = [];
      this.empresas.forEach(empresa => {
        if (this.certificado.empresas_id.includes(empresa.id)) empresas_seleccionadas.push(empresa);
      });
      return empresas_seleccionadas;
    }
  }
}
</script>

<style scoped>
  .btn-container {
    padding: 1rem;
    display: flex;
    align-self: center;
    align-items: center;
  }

  .datepicker {
    width: 100%;
  }

  .checkbox-container {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    & label {
      margin: 0;
    }
  }

  .checkbox-container-plantas {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;

    input {
      width: 0.8rem;
    }

    label {
      margin: 0;
    }
  }

  .row-items {
    padding: 1rem 0;
  }

  .input {
    width: 100%;
    border: #ccc 1px solid;
    border-radius: 0.3rem;
    padding: 5px 10px;
  }
</style>